import React from 'react';
import { Leaf } from 'lucide-react';
export function SustainabilityCallout() {
  return <section className="bg-sage-light py-[100px] px-8" id="sustainability" data-id="element-167">
      <div className="max-w-[800px] mx-auto text-center section-reveal" data-id="element-168">
        <div className="flex justify-center mb-6" data-id="element-169">
          <Leaf className="w-12 h-12 text-sage" strokeWidth={1.5} data-id="element-170" />
        </div>

        <h2 className="font-optima font-semibold text-[36px] md:text-[48px] text-charcoal mb-6" data-id="element-171">
          Certified Organic
        </h2>

        <p className="font-optima text-[20px] text-charcoal/90 leading-[1.8]" data-id="element-172">
          Glenlofty Estate is certified organic and a proud member of
          Sustainability Winegrowing Australia (SWA). Organic certification
          ensures healthier soils, stronger vines, and increased biodiversity.
        </p>
      </div>
    </section>;
}